<template>
	<MainLayout>
		<div class="container">
			<b-overlay no-wrap :show="loadingExport" />
			<div class="box">
				<b-row>
					<b-col>
						<h2 class="inline-heading">
							Cotizador de canales de venta
						</h2>
					</b-col>
				</b-row>
				<hr />

				<Filters
					id="saleschannel-reservations-index-filters"
					:filters.sync="filters"
					@search="
						() =>
							$root.$emit(
								'bv::refresh::table',
								'saleschannels-prices-index-list'
							)
					"
				/>
				<hr />
				<b-row>
					<b-col
						align-self="start"
						v-if="$hasPermission('supplierCost.updateAll')"
					>
						<b-button
							@click="$refs['refConfirm'].show()"
							variant="warning"
							class="mb-2"
						>
							CALCULAR Y ACTUALIZAR TODOS
						</b-button>
					</b-col>
					<b-col align-self="end" class="text-right">
						<b-button
							variant="primary"
							class="ml-2 mb-2"
							@click="updateAllView"
						>
							GUARDAR COSTOS
						</b-button>

						<b-button
							@click="exportExcel()"
							variant="success"
							class="ml-2 mb-2"
						>
							<md-icon icon="" />Exportar XLS
						</b-button>
					</b-col>
				</b-row>

				<!-- Modal confirmation-->
				<b-modal ref="refConfirm" title="Confirmation" hide-header>
					<p class="my-4 text-center">¿Esta seguro que quiere <strong>Calcular y actualizar todos los registros</strong>?</p>
					<template #modal-footer>
						<div class="container">
							<div class="row justify-content-center">
							<b-button
							size="sm"
							class="mr-3"
							@click="$refs['refConfirm'].hide()"
						>
							Cancelar
						</b-button>
						<b-button
							variant="primary"
							size="sm"
							@click="$refs['refConfirm'].hide(); $refs['refUpdateAll'].show(); updateAll()"
						>
							Continuar
						</b-button>
						</div>
						</div>
					</template>
				</b-modal>

				<b-modal id="update-all" ref="refUpdateAll" scrollable title="Calculando y actualizando todos los registros" ok-only ok-title="Cerrar">
					<div class="text-center">
						<div>
							<p v-for="(text, i) in updateAllSteps" :key="i">
								{{ text }}
							</p>
						</div>
						<b-spinner small v-if="runUpdateAll" />
						<br />
						<b-button
							variant="danger"
							@click="runUpdateAll = false"
							v-if="runUpdateAll"
						>
							DETENER
						</b-button>
					</div>
				</b-modal>

				<b-modal id="trace-data" size="xl" ok-only ok-title="Cerrar">
					<h4>Detalles</h4>
					<section>
						<b-form-input v-model="trace.filter" v-if="false"></b-form-input>
						<b-table responsive="md" stacked="sm"   show-empty small striped hover :items="trace.items" :fields="trace.columns" :filter="trace.filter" >
							<template #cell(ratePlanId)="row">
								<a :href="'/rate-plans-edit?id='+row.item.ratePlanId" class="btn btn-sm mr-1 btn-warning" target="__blank" v-if="$hasPermission('prices.show')" >
									<md-icon  icon="attach_money" 	v-b-modal.trace-data></md-icon>
								</a>
								<b-form-checkbox v-model="row.detailsShowing" @change="row.toggleDetails">
									Mapa
								</b-form-checkbox>
							</template>
							<template #row-details="row">
								<b-card>
									<map-zones :traceInfo="row.item" />
								</b-card>
							</template>
						</b-table>
					</section>
				</b-modal>

				<hr />
				<b-row no-gutters>
					<b-col>
						<b-badge
							v-for="(aux, i) in $root.auxVars
								.transportServiceStatusOpts"
							:key="i"
							:variant="aux.class"
							class="mr-2"
							size=""
						>
							{{ aux.text }}
						</b-badge>
					</b-col>
				</b-row>
				<AjaxTable
					permission-show="saleChannelCost.show"
					id="saleschannels-prices-index-list"
					ref="childtable"
					stacked="lg"
					:selected-items.sync="items"
					:filters="filtersClean"
					:columns="modelColumns"
					:items-filter="itemsFilter"
					:sort-by.sync="sortBy"
					:sort-desc.sync="sortDesc"
					resource="rates/prices"
					responsive
					:items.sync="itemsDisplayed"
				>
					<template #cell(actions)="row">
						<div class="d-flex">
							<b-button
								@click="
									event =>
										resView(
											row.item,
											row.index,
											event,
											row.item
										)
								"
								type="button"
								size="sm"
								class="mr-1"
								variant="info"
							>
								<md-icon icon="visibility"></md-icon>
							</b-button>
						</div>
					</template>
					<template #cell(contactStatus)="row">
						{{ contactStatusLabels[row.item.contactStatus] }}
					</template>
					<template #cell(netCurrency)="row">
						<b-form-select
							style="width: 100px"
							size="sm"
							:options="optsCurrencies"
							v-model="row.item.netCurrency"
						></b-form-select>
					</template>
					<template #cell(pickup)="row">
						<b-button
							size="sm"
							v-if="
								row.item.pickup.latitude === null ||
									row.item.pickup.longitude === null
							"
							variant="warning"
							@click="() => openPlace(row.item.pickup.id)"
						>
							<md-icon icon="not_listed_location" />
						</b-button>
						{{ row.item.pickup.name }}
					</template>
					<template #cell(dropoff)="row">
						<b-button
							size="sm"
							v-if="
								row.item.dropoff.latitude === null ||
									row.item.dropoff.longitude === null
							"
							variant="warning"
							@click="() => openPlace(row.item.dropoff.id)"
						>
							<md-icon icon="not_listed_location" />
						</b-button>
						{{ row.item.dropoff.name }}
					</template>
					<template #cell(pax)="row">
						<span style="">{{
							row.item.adults +
								row.item.children +
								row.item.infants
						}}</span>
					</template>
					<template #cell(salesChannel)="row">
						<span style="white-space: nowrap;"
							><b-badge
								v-if="row.item.sourceLabel"
								variant="info"
								class="ml-1"
								>{{ row.item.sourceLabel }}</b-badge
							>
							{{ row.item.salesChannel }}</span
						>
					</template>
					<template #cell(pickupDatetime)="row">
						<span
							:class="
								row.item.pickupDatetimeConfirmed
									? 'text-success text-center'
									: 'text-warning text-center'
							"
						>
							<md-icon
								:icon="
									row.item.pickupDatetimeConfirmed
										? 'check_circle'
										: 'warning'
								"
							/>
						</span>
						{{ row.item.pickupDatetime }}
					</template>
					<template #cell(flightDatetime)="row">
						{{ row.item.flightDatetime }} /
						{{ row.item.flightNumber }}
					</template>
					<template #cell(netPriceTotal)="row">
						<b-input-group size="sm">
							<b-form-input
								disabled
								style="width: 100px"
								type="text"
								size="sm"
								v-model="row.item.netPriceTotal"
							/>
							<template #prepend>
								<b-input-group-text>$</b-input-group-text>
							</template>
						</b-input-group>
					</template>
					<template #cell(updateNetPriceTotal)="row">
						<b-input-group size="sm">
							<b-form-input
								style="width: 150px"
								type="text"
								size="sm"
								v-model="row.item.netPriceTotalUpdated"
							/>
							<template #prepend>
								<b-input-group-text>$</b-input-group-text>
							</template>
							<template #append>
								<b-button
									:disabled="
										!$hasPermission('saleChannelCost.update')
									"
									@click="event => calculatePrice(row.item)"
									type="button"
									size="sm"
									class="mr-1"
									variant="info"
								>
									<b-spinner
										small
										v-if="loadingRow === row.item.id"
									/>
									<md-icon v-else icon="refresh"></md-icon>
								</b-button>
								<b-button v-if="trace.lastCalculated === row.item.id">
									<md-icon  icon="info_outline" 	v-b-modal.trace-data></md-icon>
								</b-button>
							</template>
						</b-input-group>
					</template>
					<template #cell(supplier)="row">
						<span
							:class="
								iconSupplierConfirmation(
									row.item.supplierConfirmation
								).class
							"
						>
							<md-icon
								:icon="
									iconSupplierConfirmation(
										row.item.supplierConfirmation
									).icon
								"
							/>
						</span>
						{{ row.item.supplier }}
						<template v-if="row.item.lastRejectedSupplierName">
							<br />Rechazado por:
							{{ row.item.lastRejectedSupplierName }}
						</template>
					</template>
					<template #cell(status)="row">
						{{ statusLabels[row.item.status] }}
					</template>
				</AjaxTable>
			</div>
			<FormReservation
				:tsSelectedId="selected.tsSelectedId"
				:model-id="selected.modalModelId"
				:copy-from-id="selected.copyResId"
				:formTypeWork="formTypeWork"
				@changeId="selected.modalModelId = $event"
				@onCopyRes="copyCurrentRes"
				v-model="form.add"
			/>
			<vue-snotify />
			<PlaceSingle
				ref="placeSingle"
				:success-callback="updatePlaceSuccessCallback"
			/>

		</div>
	</MainLayout>
</template>

<script>
import MainLayout from "../layout/MainLayout";
import AjaxTable from "../../helpers/AjaxTable";
import FormReservation from "@/components/sections/reservation/formReservation/index";
import api from "../../../api.js";
import Filters from "@/components/sections/reservations/Filters";
import PlaceSingle from "@/components/sections/places/Single";
import MapZones from "../rate-plans/Map.vue";

export default {
	components: {
		MainLayout,
		FormReservation,
		AjaxTable,
		Filters,
		PlaceSingle,
		MapZones
	},
	data() {
		let defaultFilters = {
			id: "",
			clientFullName: "",
			destination: [],
			salesChannel: [],
			supplier: [],
			airport: [],
			serviceType: [],
			serviceTypeCategory: [],
			pickupStartDate: "",
			pickupEndDate: "",
			creationStartDate: "",
			pickupStartTime: "",
			pickupEndTime: "",
			creationEndDate: "",
			cancelationStartDate: "",
			cancelationEndDate: "",
			trip: 0,
			contactStatus: 0,
			revisedStatus: null,
			status: [{ value: "active", text: "Activo" }],
			statusCheckin: [],
			salesChannelReference: "",
			supplierReference: "",
			containsEmail: "",
			clientEdited: "",
			clientConfirmed: "",
			showAdvancedOptions: false,
			pickupDatetimeConfirmed: null,
			fromPointOfSale: null,
			supplierConfirmation: null,
			placesWithoutCoordinates: null,
			supplierPriceTotalEmpty: null,
			creationUser:[],
			zones:[],
			invalidSupplierServiceType:false
		};
		let columnsTrace =[
			{key:'ride',label:'Ride'},
			{key:'ratePlan',label:'Rate plan'},
			{key:'ratePlanStartDate',label:'F. Inicio'},
			{key:'ratePlanEndDate',label:'F. Fin'},
			{key:'zoneFrom',label:'Zona origen'},
			{key:'zoneTo',label:'Zona destino'},
			{key:'service',label:'Servicio venta'},
			{key:'supplierServiceType',label:'Servicio prov.'},
			{key:'msj',label:'Msj'},
			{key:'ratePlanId',label:'link'},
		]
		return {
			trace: {filter:"",items:[],lastCalculated:-1,columns:columnsTrace},
			formTypeWork: "newForm", //viewForm -newForm- newFormCopy - newFormLocationReferences
			form: {
				add: false
			},
			selected: {
				modalModelId: -1,
				tsSelectedId: -1,
				copyResId: -1
			},
			loadingRow: -1,
			loadingExport: false,
			tsSelectedId: -1,
			items: [],
			itemsDisplayed: [],
			copyResId: -1,
			pendingNotifications: 0,
			exportLoading: false,
			modalModelId: -1,
			sortBy: "reservationId",
			sortDesc: true,
			filters: { ...defaultFilters },
			defaultFilters: { ...defaultFilters },
			updateAllSteps: [],
			runUpdateAll: false,
			modelColumns: [
				{
					key: "reservationId",
					label: "Num. Servicio",
					sortable: true,
					disabled: true,
					formatter(value, key, item){
						return item.serviceNumber
					}
				},
				{ key: "clientName", label: "Cliente" },
				{ key: "pickup", label: "Pickup" },
				{ key: "dropoff", label: "Dropoff" },
				{ key: "pax", label: "Pasajeros" },
				{
					key: "pickupDatetime",
					label: "Fecha Pickup",
					sortable: true
				},
				{ key: "flightDatetime", label: "Fecha Vuelo" },
				{ key: "serviceType", label: "Tipo servicio" },
				{ key: "salesChannel", label: "Canal de venta" },
				{ key: "salesChannelReference", label: "Referencia" },
				{ key: "supplier", label: "Proveedor" },
				//{ key: "salesChannelZoneFrom", label: "Zona pickup" },
				//{ key: "salesChannelZoneTo", label: "Zona dropoff" },
				{
					key: "netPriceTotal",
					label: "Costo actual",
					sortable: true
				},
				{ key: "updateNetPriceTotal", label: "Actualizar costo" },
				{ key: "netCurrency", label: "Moneda" },
				{ key: "trip", label: "Viaje" },
				{ key: "contactStatus", label: "Contacto" },
				{ key: "status", label: "Estado" },
				{ key: "actions", label: "Acciones", disabled: true }
			],
			pickupConfirmedOpts: [
				{ value: null, text: "TODOS" },
				{ value: true, text: "CONFIRMADOS" },
				{ value: false, text: "NO CONFIRMADOS" }
			],
			fromPointOfSaleOpts: [
				{ value: null, text: "TODOS" },
				{ value: true, text: "CON PUNTO DE VENTA" },
				{ value: false, text: "SIN PUNTO DE VENTA" }
			],
			openFilters: true
		};
	},
	computed: {
		filtersClean() {
			return {
				id: this.filters.id,
				clientFullName: this.filters.clientFullName,
				destination: this.filters.destination.map(aux => aux.value),
				airport: this.filters.airport.map(aux => aux.value),
				salesChannel: this.filters.salesChannel.map(aux => aux.value),
				supplier: this.filters.supplier.map(aux => aux.value),
				creationUser: this.filters.creationUser.map(aux => aux.value),
				serviceType: this.filters.serviceType.map(aux => aux.value),
				serviceTypeCategory: this.filters.serviceTypeCategory.map(aux => aux.value),
				pickupStartDate: this.filters.pickupStartDate,
				pickupEndDate: this.filters.pickupEndDate,
				pickupStartTime: this.filters.pickupStartTime,
				pickupEndTime: this.filters.pickupEndTime,
				creationStartDate: this.filters.creationStartDate,
				creationEndDate: this.filters.creationEndDate,
				cancelationStartDate: this.filters.cancelationStartDate,
				cancelationEndDate: this.filters.cancelationEndDate,
				trip: this.filters.trip,
				contactStatus: this.filters.contactStatus,
				revisedStatus: this.filters.revisedStatus,
				status: this.filters.status.map(aux => aux.value),
				statusCheckin: this.filters.statusCheckin.map(aux => aux.value),
				salesChannelReference: this.filters.salesChannelReference,
				supplierReference: this.filters.supplierReference,
				containsEmail: this.filters.containsEmail,
				clientEdited: this.filters.clientEdited,
				clientConfirmed: this.filters.clientConfirmed,
				pickupDatetimeConfirmed: this.filters.pickupDatetimeConfirmed,
				fromPointOfSale: this.filters.fromPointOfSale,
				supplierConfirmation: this.filters.supplierConfirmation,
				placesWithoutCoordinates: this.filters.placesWithoutCoordinates,
				supplierPriceTotalEmpty: this.filters.supplierPriceTotalEmpty,
				onlyWithAdditionalServices: this.filters.onlyWithAdditionalServices,
				oneway: this.filters.oneway,
				zones:this.filters.zones.map(aux => aux.value),
				invalidSupplierServiceType:this.filters.invalidSupplierServiceType
			};
		},
		contactStatusLabels() {
			let vars = this.$root.auxVars.transportServiceContactStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text;
			}
			return opts;
		},
		statusLabels() {
			let vars = this.$root.auxVars.transportServiceStatusOpts;
			let opts = {};
			for (let i = 0; i < vars.length; i++) {
				opts[vars[i].value] = vars[i].text;
			}
			return opts;
		},
		serviceStatusVariants() {
			let aux = {};
			this.$root.auxVars.transportServiceStatusOpts.map(status => {
				aux[status.value] = status.class;
			});
			return aux;
		},
		optsCurrencies() {
			return this.$root.auxVars.currencyOpts;
		}
	},
	methods: {
		search() {
			this.$root.$emit(
				"bv::refresh::table",
				"saleschannels-prices-index-list"
			);
		},
		calculatePrice(item) {
			this.loadingRow = item.id;
			this.trace.lastCalculated = -1;
			this.trace.items = [];
			api(this)
				.get(`/rates/sale-channel-prices/${item.id}`)
				.then(res => {
					this.trace.lastCalculated = item.id
					item.netPriceTotalUpdated = res.data.netPriceTotal;
					item.netCurrency = res.data.netCurrency;
					this.loadingRow = -1;

					this.$root.showAlert(
						`Costo calculado a $${item.netPriceTotalUpdated}`
					);
					this.trace.items = res.data.trace??[];
					this.trace.items = this.trace.items.map(v => ({...v, _showDetails: true}))
				})
				.catch(err => {
					// this.$root.handleRequestError(err);
					this.loadingRow = -1;
					if(err.response.data.trace) this.trace.items = [...err.response.data.trace];
					this.$root.handleRequestError(err);
					// this.$root.showAlert("No se encontró el precio", { variant: "danger" });

				}).finally(()=>{
					this.trace.lastCalculated = item.id
				})
		},
		updatePlaceSuccessCallback() {
			this.$root.$emit(
				"bv::refresh::table",
				"saleschannels-prices-index-list"
			);
		},
		openPlace(id) {
			this.$refs.placeSingle.loadModel(id);
		},
		doUpdateAll(offset = 0) {
			if (this.runUpdateAll) {
				this.$root.api
					.put(`rates/update-sales-channel-prices-all`, {
						limit: 50,
						offset: offset,
						filters: this.filtersClean,
						sortBy: this.sortBy,
						sortOrder: this.sortDesc ? "desc" : "asc",
					})
					.then(res => {
						this.updateAllSteps.push(
							`Actualizacion de registros ${offset +
								1} al ${offset + 50}: Se actualizaron ${
								res.data.updated
							}, ${
								res.data.noCalculated
							} registros no se pudieron actualizar`
						);
						if (res.data. transportService.length > 0) {
							this.doUpdateAll(offset + 50);
						} else {
							this.runUpdateAll = false;
						}
					})
					.catch(this.$root.handleRequestError);
			}
		},
		updateAll() {
			// primer request y toma el valor del total para calcular cuantas llamadas mas realizar
			this.runUpdateAll = true;
			this.updateAllSteps = [];
			this.doUpdateAll(0);
			// this.$root.showWarning({
			// 	okAction: (event, setLoading, close) => {
			// 		setLoading(true)
			// 		api(this).put(`/rates/update-suppliers-prices-all`, { filters : this.filtersClean }).then((res) => {
			// 			this.$root.showAlert(`Se actualizaron ${res.data.updated}, ${res.data.noCalculated} registros no se pudieron actualizar`)
			// 			this.$root.$emit('bv::refresh::table', 'saleschannels-prices-index-list')
			// 			close()
			// 		}).catch( err => {
			// 			this.$root.handleRequestError(err)
			// 			close()
			// 		});
			// 	}
			// })
		},
		updateAllView() {
			this.$root.showWarning({
				okAction: (event, setLoading, close) => {
					setLoading(true);
					api(this)
						.put(`/rates/update-sales-channel-prices`, {
							transportServices: this.itemsDisplayed.map(
								item => ({
									id: item.id,
									netPriceTotal:
										item.netPriceTotalUpdated,
									netCurrency: item.netCurrency
								})
							)
						})
						.then(res => {
							this.$root.showAlert(
								`Se actualizaron ${res.data.updated} registros`
							);
							this.$root.$emit(
								"bv::refresh::table",
								"saleschannels-prices-index-list"
							);
							close();
						})
						.catch(err => {
							this.$root.handleRequestError(err);
							close();
						});
				}
			});
		},
		copyCurrentRes() {
			this.selected.copyResId = this.selected.modalModelId;
			this.selected.modalModelId = -1;
			this.form.add = true;
		},
		itemsFilter(items) {
			if (!items) return [];
			return items.map(item => ({
				...item,
				netPriceTotalUpdated: item.netPriceTotal,
				_rowVariant: this.serviceStatusVariants[item.status]
			}));
		},
		resView(item) {
			this.selected.tsSelectedId = item.id;
			this.selected.copyResId = -1;
			this.selected.modalModelId = item.reservationId;
			this.form.add = true;
			//configuramos el estado de formulario formService
			this.formTypeWork = "viewForm";
		},
		iconSupplierConfirmation(status) {
			let icon = "";
			let classe = "";
			switch (status) {
				case "pending":
					icon = "warning";
					classe = "text-warning";
					break;
				case "confirmed":
					icon = "check_circle";
					classe = "text-success";
					break;
				case "rejected":
					icon = "dangerous";
					classe = "text-danger";
					break;
			}
			return { icon: icon, class: classe };
		},
		exportExcel() {
			this.loadingExport = true;
			api(this)
				.get(`/rates/supplier-prices/exportXls`, {
					params: { filters: this.filtersClean },
					responseType: "blob"
				})
				.then(res => {
					this.$root.downloadExcel(res, "Supplier Prices");
				})
				.catch(err => {
					this.$root.handleRequestError(err);
				})
				.finally(() => {
					this.loadingExport = false;
				});
		}
	},
	mounted() {},
	created() {},
	watch: {}
};
</script>

<style>
.multiselect__tags {
	max-height: 150px;
	overflow-y: auto;
	overflow-y: auto;
}
.active-filter {
	border: 2px solid #021d3e;
}
.snotifyToast__title {
	font-size: 1.5em;
}
.inline-heading {
	display: inline;
}
.inline-button {
	margin-bottom: 10px;
}
</style>
